export default [
  {
    author: "Renato Soldenhoff | DSS",
    authorId: "2",
    type: "Bedürfnis",
    content: "ein Ort des Austauschs",
  },
  {
    author: "Renato Soldenhoff | DSS",
    authorId: "2",
    type: "Bedürfnis",
    content:
      "Klare Angaben, wer für das Thema zuständig ist innerhalb der ZHdK",
  },
  {
    author: "Charlotte Axelsson | E-Learning",
    authorId: "4",
    type: "Bedürfnis",
    content: "Sichtbarkeit",
  },
  {
    author: "Michael Koch | ITZ",
    authorId: "10",
    type: "Bedürfnis",
    content: "Mehr Videokonferenzanlagen in den Räumen",
  },
  {
    author: "Charlotte Axelsson | E-Learning",
    authorId: "4",
    type: "Bedürfnis",
    content: "Verständniss, was digitale Lehre heisst",
  },
  {
    author: "Patrick Müller | Telematische Performance",
    authorId: "5",
    type: "Bedürfnis",
    content: "Bessere Verankerung in der Lehre",
  },
  {
    author: "Patrick Müller | Telematische Performance",
    authorId: "5",
    type: "Bedürfnis",
    content: "Zusammenhang zu den Aktivitäten an der ZHdK",
  },
  {
    author: "Paolo del Ponte | DAZ",
    authorId: "6",
    type: "Bedürfnis",
    content: "Synergien",
  },
  {
    author: "Grit Wolany | DSS",
    authorId: "7",
    type: "Bedürfnis",
    content: "Netzwerk",
  },
  {
    author: "Kristina Jungic | IASpace",
    authorId: "11",
    type: "Bedürfnis",
    content: "Wissen, wer man fragen muss",
  },
  {
    author: "Grit Wolany | DSS",
    authorId: "7",
    type: "Bedürfnis",
    content: "Sichtbarkeit schaffen",
  },
  {
    author: "Susanne Schumacher | Digitalrat",
    authorId: "8",
    type: "Bedürfnis",
    content: "Unterstützung, wie man die Infrastruktur bedienen kann",
  },
  {
    author: "Susanne Schumacher | Digitalrat",
    authorId: "8",
    type: "Bedürfnis",
    content: "Ausstatung, kleinere Räume",
  },
  {
    author: "Stefano Vannotti | Weiterbildung",
    authorId: "1",
    type: "Angebot",
    content: "Know-how zur Einrichtung des Raumes für hybrides Meeting",
  },
  {
    author: "Renato Soldenhoff | DSS",
    authorId: "2",
    type: "Angebot",
    content: "Gute Übersicht zu der internen Landschaft an der ZHdK",
  },

  {
    author: "Renato Soldenhoff | DSS",
    authorId: "2",
    type: "Angebot",
    content: "Know-how zur Einrichtung des Raumes für hybrides Meeting",
  },
  {
    author: "Mela Kocher | Ludische Didaktik",
    authorId: "3",
    type: "Angebot",
    content: "Podcast Set",
  },
  {
    author: "Mela Kocher | Ludische Didaktik",
    authorId: "3",
    type: "Angebot",
    content: "Streaming Set",
  },
  {
    author: "Mela Kocher | Ludische Didaktik",
    authorId: "3",
    type: "Angebot",
    content: "Virtual Reality Brille",
  },
  {
    author: "Charlotte Axelsson | E-Learning",
    authorId: "4",
    type: "Angebot",
    content: "Digital Assistants",
  },
  {
    author: "Charlotte Axelsson | E-Learning",
    authorId: "4",
    type: "Angebot",
    content: "NEAR Studio",
  },
  {
    author: "Charlotte Axelsson | E-Learning",
    authorId: "4",
    type: "Angebot",
    content: "ELLA Toolbox",
  },
  {
    author: "Charlotte Axelsson | E-Learning",
    authorId: "4",
    type: "Angebot",
    content: "Kommunikation via Postmaster und Newsletter",
  },
  {
    author: "Patrick Müller | Telematische Performance",
    authorId: "5",
    type: "Angebot",
    content: "Know-how zu Telematik, und andere Technologien",
  },
  {
    author: "Patrick Müller | Telematische Performance",
    authorId: "5",
    type: "Angebot",
    content: "Dienstleistungen",
  },
  {
    author: "Paolo del Ponte | DAZ",
    authorId: "6",
    type: "Angebot",
    content: "Know-how zu Transformationsprojekte und neuen Technologien",
  },
  {
    author: "Grit Wolany | DSS",
    authorId: "7",
    type: "Angebot",
    content: "Know-how zum Thema KI, und neue Trends",
  },
  {
    author: "Grit Wolany | DSS",
    authorId: "7",
    type: "Angebot",
    content: "Publizieren auf DSS Blog",
  },
  {
    author: "Susanne Schumacher | Digitalrat",
    authorId: "8",
    type: "Angebot",
    content: "Vernetzung innerhalb und auuserhalb der ZHdK",
  },
  {
    author: "Susanne Schumacher | Digitalrat",
    authorId: "8",
    type: "Angebot",
    content: "Mitdenken und Erfahrung",
  },
  {
    author: "Susanne Schumacher | Digitalrat",
    authorId: "8",
    type: "Angebot",
    content: "Know-how zum Thema Open Science",
  },
  {
    author: "Kristina Jungic | IASpace",
    authorId: "11",
    type: "Angebot",
    content: "Open-source Software",
  },
  {
    author: "Renato Soldenhoff | DSS",
    authorId: "2",
    type: "Kommentar",
    content:
      "Das M/M-Projekt hat zuwenig Räume: Also müsste es mehr digitale Angebote geben...",
  },
  {
    author: "Charlotte Axelsson | E-Learning",
    authorId: "4",
    type: "Kommentar",
    content: "Es fehlt ‘digital literacy’ bei der Entscheidungsträger",
  },
  {
    author: "Charlotte Axelsson | E-Learning",
    authorId: "4",
    type: "Kommentar",
    content: "Digital bedeutet nicht Zoom",
  },
  {
    author: "Charlotte Axelsson | E-Learning",
    authorId: "4",
    type: "Kommentar",
    content:
      "Es wäre gut, ein Interessensgemeinschaft zu kreieren, welche diese Themen repräsentiert",
  },
  {
    author: "Paolo del Ponte | DAZ",
    authorId: "6",
    type: "Kommentar",
    content: "Cloud hat alles revolutioniert",
  },
  {
    author: "Grit Wolany | DSS",
    authorId: "7",
    type: "Kommentar",
    content:
      "Alle benutzen unterschiedlichen Tools: gibt es Guidelines oder Best Practices?",
  },
  {
    author: "Susanne Schumacher | Digitalrat",
    authorId: "8",
    type: "Kommentar",
    content: "Wir müssen zeigen, was die Leute an der ZHdK können",
  },
  {
    author: "Wanja Kröger | Dossier Learning and Teaching",
    authorId: "9",
    type: "Kommentar",
    content: "Es fehlt ein argumentatives Framework",
  },
  {
    author: "Wanja Kröger | Dossier Learning and Teaching",
    authorId: "9",
    type: "Kommentar",
    content: "In welcher Richtung geht die ZHdK?",
  },
];
